import { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { customerApi, formatApiError } from "@/lib/api";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ResetPasswordPage() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 6) return toast.error("Password must be at least 6 characters");
    if (pw !== confirm) return toast.error("Passwords do not match");
    setBusy(true);
    try {
      await customerApi.post("/customer/reset-password", { token, password: pw });
      toast.success("Password updated — please sign in");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Could not reset password");
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      <Header />
      <main className="flex-1 w-full max-w-md mx-auto px-4 py-14">
        <div className="rounded-2xl border bg-white p-7 shadow-sm">
          <h1 className="text-2xl font-extrabold">Choose a new password</h1>
          <form onSubmit={submit} className="space-y-3 mt-5">
            <div><Label>New password</Label><Input data-testid="reset-password" type="password" value={pw} onChange={(e) => setPw(e.target.value)} required /></div>
            <div><Label>Confirm password</Label><Input data-testid="reset-confirm" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required /></div>
            <Button type="submit" data-testid="reset-submit" disabled={busy} className="w-full h-11 bg-steel text-white hover:bg-steel-light font-semibold">
              {busy ? "Updating…" : "Update password"}
            </Button>
          </form>
        </div>
      </main>
      <Footer />
    </div>
  );
}
